import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { compose } from "recompose";

import { UserStore } from "nvent-web/stores/User";

import Login from "./Login";
import Register from "./Register";

export interface AuthInnerProps extends RouteComponentProps<{}> {
  user: UserStore;
}

export class AuthInner extends Component<AuthInnerProps> {
  render() {
    const { user } = this.props;
    const { path, url } = this.props.match;

    return (
      <Switch>
        <Route path={`${path}/register`} exact={false} component={Register} />
        {user.shouldCreateProfile && <Redirect to={`${url}/register`} />}

        <Route path={`${path}/login`} exact={false} component={Login} />
        <Redirect to={`${url}/login`} />
      </Switch>
    );
  }
}

export const Auth = compose<AuthInnerProps, {}>(
  inject("user"),
  withRouter,
  observer
)(AuthInner);
Auth.displayName = "Auth";

export default Auth;
